(() => {
  const root = document.querySelector('[data-sidiz-about]');
  if (!root) return;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const syncVideoControl = (video) => {
    const button = video.closest('[data-video-stage]')?.querySelector('[data-video-toggle]');
    if (!button) return;
    button.setAttribute('aria-label', video.paused ? 'Play campaign film' : 'Pause campaign film');
  };

  const attemptPlayback = (video) => {
    if (!video.autoplay || reduceMotion) {
      syncVideoControl(video);
      return;
    }
    const play = () => video.play().catch(() => syncVideoControl(video));
    if (video.readyState >= 2) play();
    else video.addEventListener('canplay', play, { once: true });
  };

  const loadVideo = (video) => {
    if (video.dataset.loaded === 'true') return;
    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.dataset.loaded = 'true';
    video.load();
    attemptPlayback(video);
  };

  const videos = root.querySelectorAll('video[data-lazy-video]');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadVideo(entry.target);
        currentObserver.unobserve(entry.target);
      });
    }, { rootMargin: '320px 0px' });
    videos.forEach((video) => observer.observe(video));
  } else {
    videos.forEach(loadVideo);
  }

  root.querySelectorAll('[data-video-toggle]').forEach((button) => {
    const video = button.closest('[data-video-stage]')?.querySelector('video');
    if (!video) return;
    video.addEventListener('play', () => syncVideoControl(video));
    video.addEventListener('pause', () => syncVideoControl(video));
    button.addEventListener('click', () => {
      loadVideo(video);
      if (video.paused) video.play().catch(() => syncVideoControl(video));
      else video.pause();
    });
    syncVideoControl(video);
  });

  root.querySelectorAll('[data-youtube-id]').forEach((button) => {
    button.addEventListener('click', () => {
      const stage = button.closest('[data-youtube-stage]');
      if (!stage || stage.querySelector('iframe')) return;
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${button.dataset.youtubeId}?autoplay=1&rel=0&modestbranding=1`;
      iframe.title = button.getAttribute('aria-label') || 'Campaign film';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      stage.appendChild(iframe);
      stage.querySelector('img')?.remove();
      button.remove();
    });
  });
})();
